import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { TRoleItem } from '@/data/types';

interface SuccessStepProps {
  email: string;
  selectedRole: TRoleItem | null;
  selectedPermissions: string[];
  onSendAnother: () => void;
  onBackToPersonnel: () => void;
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  email,
  selectedRole,
  selectedPermissions,
  onSendAnother,
  onBackToPersonnel,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="mx-auto mt-8 max-w-xl text-center"
    >
      <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
        <CheckCircle className="h-10 w-10 text-green-600" />
      </div>
      <h2 className="mb-4 text-2xl font-bold text-gray-900">Η Πρόσκληση Στάλθηκε!</h2>
      <div className="mb-8 space-y-3">
        <p className="text-gray-600">Η πρόσκληση στάλθηκε επιτυχώς στο:</p>
        <p className="text-lg font-medium text-blue-600">{email}</p>
        <div className="rounded-lg bg-gray-50 p-4 text-left">
          <p className="text-sm text-gray-700">
            <strong>Ρόλος:</strong> {selectedRole?.name}
          </p>
          <p className="mt-1 text-sm text-gray-700">
            <strong>Δικαιώματα:</strong> {selectedPermissions.length} επιλεγμένα
          </p>
        </div>
      </div>
      <div className="space-y-3">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onSendAnother}
          className="w-full rounded-xl bg-blue-600 px-6 py-3 font-medium text-white shadow-lg transition-colors hover:bg-blue-700"
        >
          Στείλε Άλλη Πρόσκληση
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onBackToPersonnel}
          className="w-full rounded-xl bg-gray-100 px-6 py-3 font-medium text-gray-700 transition-colors hover:bg-gray-200"
        >
          Επιστροφή στο Προσωπικό
        </motion.button>
      </div>
    </motion.div>
  );
};

export default SuccessStep;
